import React, { FC } from 'react';
import classnames from 'classnames';

import './style.scss';

export interface LoaderProps {
    className?: string;
    ariaLabel?: string;
    mini?: boolean;
}

const Loader: FC<LoaderProps> = ({ className, ariaLabel = 'Vent Litt', mini }) => {
    const rootStyle = {
        width: mini ? '32px' : '50px',
        margin: '0 auto',
    };
    return (
        <div
            className={classnames('sgw-loader', className, { 'loader--mini': mini })}
            role="status"
            aria-label={ariaLabel}
            style={rootStyle}
        >
            <svg viewBox="-25 -25 50 50" width="100%" className="spin">
                <path
                    style={{ fill: 'none', stroke: 'var(--spinner-medium-color)' }}
                    d="M -22 0 A 22 22 0 0 1 0 -22 "
                    strokeWidth="5"
                />
                <path
                    style={{ fill: 'none', stroke: 'var(--spinner-light-color)' }}
                    d="M 0 -22 A 22 22 0 0 1 22 0 "
                    strokeWidth="5"
                />
                <path
                    style={{ fill: 'none', stroke: 'var(--spinner-dark-color)' }}
                    d="M 22 0 A 22 22 0 0 1 0 22 "
                    strokeWidth="5"
                />
                <path
                    style={{ fill: 'none', stroke: 'var(--spinner-pastel-color)' }}
                    d="M 0 22 A 22 22 0 0 1 -22 0 "
                    strokeWidth="5"
                />
                <circle
                    style={{ fill: 'var(--spinner-medium-color)', stroke: 'var(--spinner-medium-color)' }}
                    cx="0"
                    cy="-22"
                    r="2.5"
                    strokeWidth="0"
                />
                <circle
                    style={{ fill: 'var(--spinner-light-color)', stroke: 'var(--spinner-light-color)' }}
                    className="seagreen-pastel"
                    cx="22"
                    cy="0"
                    r="2.5"
                    strokeWidth="0"
                />
                <circle
                    style={{ fill: 'var(--spinner-dark-color)', stroke: 'var(--spinner-dark-color)' }}
                    cx="0"
                    cy="22"
                    r="2.5"
                    strokeWidth="0"
                />
                <circle
                    style={{ fill: 'var(--spinner-pastel-color)', stroke: 'var(--spinner-pastel-color)' }}
                    cx="-22"
                    cy="0"
                    r="2.5"
                    strokeWidth="0"
                />
            </svg>
        </div>
    );
};

export default Loader;
